import { render } from "./Usage.vue?vue&type=template&id=f064c57a&scoped=true"
import script from "./Usage.vue?vue&type=script&lang=js"
export * from "./Usage.vue?vue&type=script&lang=js"

import "./Usage.vue?vue&type=style&index=0&id=f064c57a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f064c57a"]])

export default __exports__